import { TulipAssetConstant } from "../TulipAssetConstants";
import { EntityManager } from "../../cocos/scripts/plan/EntityManager";
import { PlanManager } from "../../cocosPlan";
import { ArrangementGroup, ArrangementObject, CeilingBox, Commands, ComponentConstants, Entity, EntityDefaultPropertiesManager, Events, eventsManager, Functionality, Hood, HttpService, Joinery, JoineryType, RenderCamera, RendererTopView, Room, SavaneCookie, SceneConstants, Staircase, Sun, TechnicalElement, TemporaryRenderCamera, Wall, WallType } from "@rhinov/savane-js";
import { _ASSET_TYPE, ARRMGR_CLOUDINARY_ALLOWED, ARRMGR_CLOUDINARY_URL, getAssets, getMediaArrangementUrl, getToken, getUrl } from "@rhinov/asset-manager-service";



declare var $: any;

export class EntityController {
    
    imgPitch = null;
    model = TulipAssetConstant.getinstance().getmodel()
    itemPreview: string | null = null;
    dropDownData: any[] = [];
    entityChildren: any = [];
    entityChildrenBis: any = [];
    dropDownDatas = TulipAssetConstant.getinstance().getdropDownDatas();
    entity: Entity;
    panel: any;
    propertiesTab: string[];
    openAssetDetailCallback: CallableFunction | null;
    deliverable: any;
    arrangement: any;

    constructor(entity: Entity, panel: any, deliverable: any, openAssetDetailCallback: CallableFunction | null = null) {
        this.entity = entity;
        this.panel = panel;
        this.propertiesTab = [];
        this.openAssetDetailCallback = openAssetDetailCallback;
        this.deliverable = deliverable;
        this.initModel();
    }

    openEntityDetail(): void{};

    moveChildUp(item: any, callback: CallableFunction) {
        var index = this.entity.children.indexOf(item.entity);
        if (index !== -1 && index > 0) {
            this.entity.children.splice(index, 1);
            this.entity.children.splice(index - 1, 0, item.entity);
            this.setupchildList(callback);
        }
    };

    moveChildDown(item: any, callback: CallableFunction) {
        var index = this.entity.children.indexOf(item.entity);
        if (index !== -1 && index + 1 < this.entity.children.length) {
            this.entity.children.splice(index, 1);
            this.entity.children.splice(index + 1, 0, item.entity);
            this.setupchildList(callback);
        }
    };

    extractItem(entityToExtract: Entity) {
        eventsManager.instance.dispatch(Events.UNGROUP_ENTITY, entityToExtract);
    };

    setToggleValue(property: any, value: any) {
        //FIXME WHat is that ?
        /*if (obj.locked === true) {
            return;
            }*/
        if (value !== null) {
            // Force width adjustment in the event of isSpecialWall which show/hides extra things
            if (property === "isSpecialWall") {
                var planManager = PlanManager.getInstance();
                var i;
                var componentList;
                let wall = this.entity as Wall;

                // If is special set to true, then remove all joineries and coatings
                if (value === true) {
                    componentList = wall.getComponents(ComponentConstants.ComponentType.Coating);

                    for (i = componentList.length - 1; i >= 0; i--) {
                        planManager.executeCommand(new Commands.DeleteComponentCommand(componentList[i], false));
                    }

                    planManager.executeCommand(new Commands.DeleteJoineriesCommand(wall.joineries));

                    var component = new WallType(SavaneCookie.getCookie("Rhinov-Savane-DefaultWallModel", SceneConstants.DefaultWallType.balconyRail));
                    component.entity = wall;

                    planManager.executeCommand(new Commands.AddComponentCommand(component, wall, true, false));

                    wall.height = 1000;
                }
                else {
                    componentList = this.entity.getComponents(ComponentConstants.ComponentType.WallType);

                    for (i = componentList.length - 1; i >= 0; i--) {
                        planManager.executeCommand(new Commands.DeleteComponentCommand(componentList[i], false));
                    }

                    if (wall.rooms.length > 0) {
                        wall.height = wall.rooms[0].height;
                        if (wall.rooms.length > 1) {
                            if (wall.height < wall.rooms[1].height) {
                                wall.height = wall.rooms[1].height
                            }
                        }
                    }
                    else {
                        wall.height = EntityDefaultPropertiesManager.getInstance().getWallDefaultHeight();
                    }
                }
            }

            if (property === 'transom') {
                let joinery = this.entity as Joinery; 
                joinery.transomHeight = joinery.floorHeight + joinery.height + 500;
                if ((joinery.parent as Wall).height < joinery.transomHeight) {
                    joinery.transomHeight = (joinery.parent as Wall).height;
                }

                if (joinery.transomHeight - (joinery.floorHeight + joinery.height) < 100) {
                    joinery.transom = false;
                    this.updateProperties(undefined);
                    return;
                }
            }

            if (property === 'bottomTransom') {
                let joinery = this.entity as Joinery;
                if (joinery.floorHeight - joinery.bottomTransomHeight < 100) {
                    joinery.bottomTransom = false;
                    this.updateProperties(undefined);
                    return;
                }
            }

            if (property === "hd") {
                let camera = this.entity as RenderCamera
                if (camera.format === SceneConstants.CameraPreset.Free) {
                    if (value) {
                        if (camera.temporary === null) {
                            camera.renderWidth *= 2;
                            camera.renderHeight *= 2;
                        }
                        else {
                            (camera.temporary as TemporaryRenderCamera).renderWidth *= 2;
                            (camera.temporary as TemporaryRenderCamera).renderHeight *= 2;
                        }
                    }
                    else {
                        if (camera.temporary === null) {
                            camera.renderWidth /= 2;
                            camera.renderHeight /= 2;
                        }
                        else {
                            (camera.temporary as TemporaryRenderCamera).renderWidth /= 2;
                            (camera.temporary as TemporaryRenderCamera).renderHeight /= 2;
                        }
                    }
                }
            }

            //Is a number check for multiplicateur conversion
            eventsManager.instance.dispatch(Events.SLIDER_BUTTON, {
                editedProperty: property,
                value: value,
                obj: this.entity
            });
            if (property === "hd") {
                this.updateProperties(undefined);
            }

        } else {
            //Update other type of properties
            this.updateProperties(undefined);
        }
        this.updateProperties(undefined);
    };

    addPropertiesValues(property: any, value: any) {
        //FIXME What is lock ?
        /* if ($this.currentTulip.params.obj.locked === true) {
            return;
            }*/
        eventsManager.instance.dispatch(Events.PLUS_CLICKED, {
            editedProperty: property,
            value: value,
            obj: this.entity
        });
        
        this.checkSpecialProperties(property, value);
    };

    blameLayout() {
        var url = getUrl() + 'api/v1/layouts/' + (this.entity as ArrangementGroup).AMLayoutId + '/blame?apikey=' + getToken();

        HttpService.put(url, undefined)
            .then(
                function(response) {
                    //success
                    if (response.status === 200) {
                        eventsManager.instance.dispatch(Events.DISPLAY_TOASTER, { message: 'Peuplement signalé à l\'AssetManager.' });
                        //this.hideTab();
                    }
                    else {
                        eventsManager.instance.dispatch(Events.DISPLAY_TOASTER, { message: 'Signalement à l\'AssetManager impossible.', error: true });
                    }
                },
                function(_response: any) {
                    //error
                    eventsManager.instance.dispatch(Events.DISPLAY_TOASTER, { message: 'Signalement à l\'AssetManager impossible.', error: true });
                });
    }

    updatecolor() {
        let color = document.getElementById('colorSelector');
        if (color) {
            if (this.model['temperature'] === '3') {
                color.classList.remove('hide');
            } else {
                color.classList.add('hide');
            }
        }

    }
            

    updateProperties(key?: string) {
        var i;
        for (i = 0; i < this.propertiesTab.length; i++) {
            if ((this as any)['update' + this.propertiesTab[i]] !== undefined)
            (this as any)['update' + this.propertiesTab[i]](this.panel.properties[i], key ? key : this.panel.key);
        }
    }

    initFunctionalityModel(entity: Room, functionalityId: number) {
        switch (functionalityId) {
            case ComponentConstants.Functionalities.Livingroom:
                this.model.sofaType = "" + entity.getData("sofaType");
                break;

            case ComponentConstants.Functionalities.Diningroom:
                this.model.bannedTableMaterialType = "" + entity.getData("bannedTableMaterialType");
                break;

            case ComponentConstants.Functionalities.Kitchen:
                this.model.kitchenShape = "" + entity.getData("kitchenShape");
                this.model.mealZone = "" + entity.getData("mealZone");
                this.model.doorType = "" + entity.getData("doorType");
                //scope.loadCuisinellaDoorCoatings(scope.model.doorType);
                break;

            case ComponentConstants.Functionalities.Library:
                this.model.libraryType = "" + entity.getData("libraryType");
                break;

            case ComponentConstants.Functionalities.Office:
                this.model.deskType = "" + entity.getData("deskType");
                break;
        }
    }

    initModel() {
        switch (this.entity.entityType) {
            case SceneConstants.EntityType.Joinery:
                this.model.materialType = "" + (this.entity as Joinery).materialType;
                break;

            case SceneConstants.EntityType.Staircase:
                let stair = this.entity as Staircase
                this.model.closureType = "" + stair.closureType;
                this.model.limonType = "" + stair.limonType;
                this.model.materialType = "" + stair.materialType;
                this.model.rampMaterialType = "" + stair.rampMaterialType;
                break;

            case SceneConstants.EntityType.ArrangementObject:
                let object = this.entity as ArrangementObject
                this.model._colorId = "" + object.colorId;
                this.model.temperature = "" + object.temperature;
                this.model.lightColor = "" + object.lightColor;
                break;

            case SceneConstants.EntityType.RenderCamera:
                let camera = this.entity as RenderCamera
                this.model.renderType = "" + camera.renderType;
                this.model.cameraType = "" + camera.cameraType;
                this.model.format = "" + camera.format;
                this.model.quality = "" + camera.quality;
                break;

            case SceneConstants.EntityType.Sun:
                let sun = this.entity as Sun
                this.model.weather = "" + sun.weather;
                this.model.exterior = sun.exterior;
                this.model.additionalExterior = sun.additionalExterior;
                break;

            case SceneConstants.EntityType.Room:
                let room = this.entity as Room
                var component = this.entity.getComponent(ComponentConstants.ComponentType.Functionality) as Functionality;

                if (component !== null) {
                    this.initFunctionalityModel((this.entity as Room), component.functionalityId!);
                }

                this.model.plinthsMaterialType = "" + room.plinthsMaterialType;
                this.model.cornicesMaterialType = "" + room.cornicesMaterialType;
                this.model.cornicesHeight = "" + room.cornicesHeight;
                this.model.cornicesDepth = "" + room.cornicesDepth;
                break;

            case SceneConstants.EntityType.TechnicalElement:
                let element = this.entity as TechnicalElement;
                this.model.materialType = "" + element.materialType;
                this.model.intensity = "" + element.intensity;
                this.model.shapeType = "" + element.shapeType;
                this.model.temperature = "" + element.temperature;
                this.model.lightColor = "" + element.lightColor;
                break;

            // case SceneConstants.EntityType.FunctionalityChip:
            //     this.initFunctionalityModel(this.entity, this.entity.functionality);
            //     break;

            case SceneConstants.EntityType.GeometryPrimitive:
                this.model.shapeType = "" + (this.entity as Hood).shapeType;
                break;
        }

        this.initColorPicker();
    }

    initColorPicker() {
        this.updatecolor();
        if (this.model.temperature !==  "" + SceneConstants.LightTemperature.color) return;

        setTimeout(() => {
            $('.color-picker-tulip').spectrum({  //FIXME keep Jquery dependances for the moment
                preferredFormat: 'hex',
                color: this.model.lightColor,
                showInput: true,
                showButtons: false,
                move: (value: any) => {
                    this.model.lightColor = value.toHex();
                    this.setPropertiesValues('lightColor', this.model.lightColor, 1);
                }
            });
        });
    }


    checkSpecialProperties(property: any, value: any) {
        if (property === "materialType") {
            var component = this.entity.getComponent(ComponentConstants.ComponentType.JoineryType) as JoineryType;

            // Lapeyre custom canopy
            if (component && (component.joineryTypeId === "5fad1c4a8f1b8b7ad9c2ce98")) {
                // Only available white, black, grey and taupe
                if (value !== '0' && value !== '4' && value !== '6' && value !== '9') {
                    value = '0';
                    this.model.materialType = '0';
                    (this.entity as Joinery).materialType = 0;
                }
            }
        }

        if (property === "roomHeight") {
            PlanManager.getInstance().scene.currentFloor!.readjustFloorsHeight();
        }

        // Potentially recalculate camera height if axo and recompute camera Nb
        if (property === "cameraType") {
            this.updateProperties(undefined);

            (this.entity as RenderCamera).updateCameraNb(PlanManager.getInstance().world);
        }

        // Change camera rendering format. If < 8, then lock resolution
        if (property === "format") {
            switch((this.entity as RenderCamera).format) {
                case SceneConstants.CameraPreset.ContentFactory:
                case SceneConstants.CameraPreset.Marketing16_9:
                case SceneConstants.CameraPreset.Marketing3_4:
                case SceneConstants.CameraPreset.MarketingStory:
                    this.setPropertiesValues("fov", "" + SceneConstants.CameraPerspectiveMarketingFOV, 1);
                    this.setPropertiesValues("quality", "" + 3, 1);
                    this.setPropertiesValues("autoexposure", "" + 0, 1);
                    setTimeout(() => {
                        this.setPropertiesValues("exposure", "" + 13, 1);
                        this.updateProperties();
                    })
                    break;
            }
            this.updateProperties(undefined);
        }

        if (property === "renderWidth") {
            if ((this.entity as RenderCamera).cameraType === SceneConstants.CameraType.Panoramic) {
                this.setPropertiesValues("renderHeight", "" + (this.entity as RenderCamera).renderWidth, 1);
                this.updateProperties(undefined);
            }
        }

        if (property === '_colorId') {
            // We do as if we delete the current object
            eventsManager.instance.dispatch(Events.COMMAND_EXECUTED,
                {
                    name: Commands.CommandEnum.DeleteEntityCommand,
                    undo: false,
                    datas: {
                        id: this.entity.id,
                        type: this.entity.entityType,
                        entity: this.entity
                    }
                });
            let object = this.entity as ArrangementObject
            object.width = this.arrangement.configs[object.colorId - 1].dimensions.length;
            object.length = this.arrangement.configs[object.colorId - 1].dimensions.width;
            object.height = this.arrangement.configs[object.colorId - 1].dimensions.height;
            if (object.originalWidth !== undefined) {
                object.originalWidth = object.width;
            }
            if (object.originalLength) {
                object.originalLength = object.length;
            }
            if (object.originalHeight) {
                object.originalHeight = object.height;
            }

            var comp = object.getComponent(ComponentConstants.ComponentType.RendererTopView) as RendererTopView;
            if (comp) {
                comp.urlTopview = getMediaArrangementUrl() + object.objectId + '/medias/previews/top_view' + object.colorId + '.webp';
                if (ARRMGR_CLOUDINARY_ALLOWED) {
                    comp.urlTopview = ARRMGR_CLOUDINARY_URL + object.objectId + '/medias/previews/top_view' + object.colorId + '.webp';
                }
            }

            var room = object.parent!;
            while (!room.isRoomEntity()) {
                if (room.isArrangementGroupEntity()) {
                    room.recenter();
                }
                if (room.isFloorEntity()) {
                    room = null as any;
                    break;
                }
                else {
                    room = room.parent!;
                }
            }
            object.updateFloorHeightFromAnchor(room as Room, PlanManager.getInstance().world.currentScene!.currentFloor!);

            // Inform WebGL to update this object by adding it back to the scene
            eventsManager.instance.dispatch(Events.COMMAND_EXECUTED,
                {
                    name: Commands.CommandEnum.AddEntityCommand,
                    undo: false,
                    datas: {
                        id: this.entity.id,
                        type: this.entity.entityType,
                        entity: this.entity
                    }
                });

            var node = EntityManager.getInstance().getNode(this.entity);
            if (node) {
                node.loadSprite(false);
            }
        }
    };

    getRangeMin(property: any): number {
        if (this.entity.isRenderCameraEntity()) {
            if (property.key === "exposure" && (this.entity as RenderCamera).autoexposure == false) {
                return -15;
            }
        }
        return property.min;
    };

    getRangeMax(property: any): number {
        if (this.entity.isRenderCameraEntity()) {
            if (property.key === "exposure" && (this.entity as RenderCamera).autoexposure == false) {
                return 15;
            }
        }
        return property.max;
    };

    setPropertiesValues(property: any, value: any, multiplicateur: number) {
        //FIXME WHat is that ?
        /*if (obj.locked === true) {
            return;
            }*/
        if (property === 'text') {
            eventsManager.instance.dispatch(Events.TEXTFIELD_EDIT, {
                editedProperty: property,
                value: value,
                obj: this.entity
            });
            return;
        }

        if (value !== null && !isNaN(value)) {
            //Is a number check for multiplicateur conversion
            var realValue = multiplicateur === undefined ? value : value * multiplicateur;
            if (!isNaN((this.entity as any)[property]) && (this.entity as any)[property] === realValue) { // nothing change so do nothing
                return;
            }

            if (property === "roomHeight") {
                // Record wall height
                EntityDefaultPropertiesManager.getInstance().setWallDefaultHeight(value * 10);
            }

            if (property === "temperature") {
                this.initColorPicker();
            }


            eventsManager.instance.dispatch(Events.TEXTFIELD_EDIT_ENDED, {
                editedProperty: property,
                value: value === "" ? null : parseFloat(realValue),  //FIXME : colorId =0 ?
                obj: this.entity
            });          
            this.checkSpecialProperties(property, value);
        }
        else {
            if (property === "exterior" || property === "additionalExterior" || property === "lightColor") {
                eventsManager.instance.dispatch(Events.TEXTFIELD_EDIT_ENDED, {
                    editedProperty: property,
                    value: value,  //FIXME : colorId =0 ?
                    obj: this.entity
                });
            }
            else {
                //Update other type of properties
                this.updateProperties(undefined);
            }
        }
    };

    getDataName(name: string): string {
        return name;
    }

    dispvalue(value: number): string {
        if (value === undefined || value === null)
            return ('');

        return value.toString();
    }

    enabledPropertiesValues(property: string): boolean {
        if (this.entity.isJoineryEntity()) {
            switch (property) {
                case 'length':
                case 'height':
                case 'nbCasement':
                    return (this.entity as Joinery).scalable;

                //case 'materialType':
                //    return (this.entity.freeColor === undefined || this.entity.freeColor === true);
            }
        }
        return true;
    }

    showPropertiesValues(property: string): boolean {
        if (this.entity.isRenderCameraEntity()) {
            switch (property) {
                case 'verticalShift':
                    return (this.entity as RenderCamera).cameraType === SceneConstants.CameraType.Perspective;
            }
        }
        return true;
    }

    dynamicRangeCall(funcName: string, arg: Object): string {
        return ((this as any)[funcName](arg) || arg);
    }

    updateplusLess(prop: any) {
        //Value is a number with +/- buttons, the value is in mm and should be displayed in cm
        if (prop.kind === 'plus-less-cm'){

            this.lockCappedPlusLess(prop.key, "", this.entity.addToCappedProperty(prop.key, 0));
            var value = Math.round(((this.entity as any)[prop.key] / 10));
            const element = document.getElementById('box-' + prop.key) as HTMLInputElement;
            if (!element) return;
            element.value = value + '';
            return;
        }
        //Value is a number with +/- buttons
        this.lockCappedPlusLess(prop.key, "", this.entity.addToCappedProperty(prop.key, 0));
        var element = document.getElementById('box-' + prop.key) as HTMLInputElement;
        if (!element) return;
        
        if ((this.entity as any)[prop.key] !== undefined) {
            element.value = (this.entity as any)[prop.key] + '';
        }
        else {
            if (this.entity.isFunctionalityChipEntity() || this.entity.isRoomEntity()) {
                if ((this.entity as Room).getData(prop.key) !== undefined) {
                    element.value = (this.entity as Room).getData(prop.key) + '';
                }
            }
        }     
    }

    lockCappedPlusLess(key: string, specifier: string, capped: number) {
        var selector = document.getElementById(`plus${specifier}-` + key)
        var selector2 = document.getElementById(`less${specifier}-` + key);

        if (!selector || !selector2) return;
        if (capped === 0) {
            selector.classList.remove('disabled');
            selector2.classList.remove('disabled');
        } else if (capped === 3) {
            selector.classList.add('disabled');
            selector2.classList.add('disabled');
        } else if (capped === 2) {
            selector.classList.add('disabled');
            selector2.classList.remove('disabled');
        } else if (capped === 1) {
            selector.classList.remove('disabled');
            selector2.classList.add('disabled');
        }
    };

    updaterange(prop: any) {
        var value = (this.entity as any)[prop.key];
        var object = document.getElementById('range-' + prop.key) as HTMLInputElement;
        if (object){
            object.value = value;
        }
        let dynamicvalue = document.getElementById(`valueRange-${prop.key}`);
        if (dynamicvalue) {
            dynamicvalue.innerHTML = `
                ${prop.title} : ${this.dynamicRangeCall(prop.funcLabel, (this.entity as any)[prop.key])}`;
        }
        if (this.entity.entityType === SceneConstants.EntityType.Joinery) {
            var container = document.getElementById(`rangeContainer-${prop.key}`);
            if (container) {
                if ((this.entity as any).isOpened) {
                    container.classList.remove('hide');
                } else {
                    container.classList.add('hide');
                }
            } 

        }
    }

    updatetripleToggle(prop: any) {
        switch (prop.key) {
            case 'shiftDirection':
                var element = document.getElementById('triple-' + prop.key);
                if (!element) return;
                if (!(this.entity as Wall).canBeOffset()) {
                    element.classList.add('hide');
                }
                else {
                    element.classList.remove('hide');
                }
            case 'wallInstallType':
            case 'lengthModifier':
                var middle = document.getElementById(`radio-middle1${prop.key}`) as HTMLInputElement;
                var left = document.getElementById(`radio-right1${prop.key}`) as HTMLInputElement;
                var right = document.getElementById(`radio-left1${prop.key}`) as HTMLInputElement;
                if (!middle || !right || !left) return;
                switch ((this.entity as any)[prop.key]) {
                    case -1:
                        middle.checked = false;
                        left.checked = true;
                        right.checked = false;
                        break;

                    case 1:
                        middle.checked = false;
                        left.checked = false;
                        right.checked = true;
                        break;

                    default:
                        middle.checked = true;
                        left.checked = false;
                        right.checked = false;
                }
                break;

            default:
                break;
        }
    }

    updatebuttonToggle(prop: any) {
        //Value is a boolean displayed using a toggle button
        var element = document.getElementById('buttonToggle-' + prop.key) as HTMLInputElement;
        if (!element) return;
        if ((this.entity as any)[prop.key] !== undefined) {
            element.checked = (this.entity as any)[prop.key];
        }
        else {
            if (this.entity.isFunctionalityChipEntity() || this.entity.isRoomEntity()) {
                if ((this.entity as Room).getData(prop.key) !== undefined) {
                    element.checked = (this.entity as Room).getData(prop.key);
                }
            }
        }
    }

    updatebuttonToggleLight(prop: any) {
        this.updatebuttonToggle(prop);
    }

    updatebuttonToggleShutter(prop: any) {
        var rollingShutter = null;
        var element = document.getElementById('buttonToggle-' + prop.key) as HTMLInputElement;
        if (!element) return;
        if (this.entity !== null && this.entity.children !== undefined && this.entity.children !== null) {
            for (var j = 0; j < this.entity.children.length; j++) {
                if (this.entity.children[j].entityType === SceneConstants.EntityType.TechnicalElement &&
                    (this.entity.children[j] as TechnicalElement).objectId === SceneConstants.TechnicalElementType.ceilingBox &&
                    (this.entity.children[j] as CeilingBox).ceilingBoxType === SceneConstants.CeilingBoxType.rollingShutter) {
                    rollingShutter = this.entity.children[j];
                }
            }
        }
        if (rollingShutter === null) {
            element.checked = false;
        }
        else {
            element.checked = true;
        }
    }

    updatenumValueToggle(prop: any) {
        //Value is a boolean displayed using a toggle button
        var element = document.getElementById('buttonToggle-' + prop.key) as HTMLInputElement;
        if (!element) return;
        element.checked = (this.entity as any)[prop.key];

        this.lockCappedPlusLess(prop.key, 'Height', this.entity.addToCappedProperty(prop.key + 'Height', 0));
        var height = document.getElementById('boxHeight-' + prop.key) as HTMLInputElement;
        var materials = document.getElementById('plinthsMaterialType');
        if (height) {
            height.value = Math.round(((this.entity as any)[prop.key + 'Height']) / 10) + '';
        }
        let modifier = document.getElementById('plinthHeight-' + prop.key);
        if (modifier) {
            if (!(this.entity as any)[prop.key]) {
                modifier.classList.add('hide');
            } else {
                modifier.classList.remove('hide');
            }
        }
        if (materials) {
            if (!(this.entity as any)[prop.key]) {
                materials.classList.add('hide');
            } else {
                materials.classList.remove('hide');
            }
        }
    }

    updatestaticCm(prop: any) {
        var valueStaticCm = Math.round(((this.entity as any)[prop.key] / 10));
        var cm = document.getElementById('static' + prop.key) as HTMLInputElement;
        if (!cm) return;
        cm.value = valueStaticCm + '';
    }

    setupchildList(updatecallback: CallableFunction) {
        var listId = '';
            for (var j = 0; j < this.entity.children.length; j++) {
                if (this.entity.children[j].entityType === SceneConstants.EntityType.ArrangementObject) {
                    listId += (listId === '' ? '' : ',') + (this.entity.children[j] as ArrangementObject).objectId;
                }
            }

            this.entityChildren = this.entity.children;
            //TODO Avoid calling getAssets with an emptu array
            var callback = (resources: any) => {
                this.entityChildrenBis = [];
                var groupCount = 0;
                for (var i = 0; i < this.entityChildren.length; i++) {
                    //
                    var binded_object: any = null;
                    if (this.entityChildren[i].entityType === SceneConstants.EntityType.ArrangementObject) {
                        for (var j = 0; j < resources.length; j++) {
                            if (resources[j]._id === this.entityChildren[i]._objectId) {
                                //Object found
                                if (this.entity.isArrangementGroupEntity() && (this.entity as ArrangementGroup).arrangementGroupType === "composition")
                                {
                                    binded_object = {
                                        entity: this.entityChildren[i],
                                        name: resources[j].configs[this.entityChildren[i]._colorId - 1].name,
                                        preview: getMediaArrangementUrl() + resources[j]._id + '/medias/previews/preview1-sm.webp'
                                    };
                                    if (ARRMGR_CLOUDINARY_ALLOWED) {
                                        binded_object.preview = ARRMGR_CLOUDINARY_URL + resources[j]._id + '/medias/previews/preview1-sm.webp';
                                    }
                                }
                                else {
                                    binded_object = {
                                        entity: this.entityChildren[i],
                                        name: resources[j].name,
                                        preview: getMediaArrangementUrl() + resources[j]._id + '/medias/previews/preview' + this.entityChildren[i]._colorId + '-sm.webp'
                                    };
                                    if (ARRMGR_CLOUDINARY_ALLOWED) {
                                        binded_object.preview = ARRMGR_CLOUDINARY_URL + resources[j]._id + '/medias/previews/preview' + this.entityChildren[i]._colorId + '-sm.webp';
                                    }
                                }
                            }
                        }
                    } else if (this.entityChildren[i].entityType === SceneConstants.EntityType.ArrangementGroup) {
                        groupCount++;
                        binded_object = {
                            entity: this.entityChildren[i],
                            name: 'Group' + groupCount,
                            preview: null
                        };
                    } else if (this.entityChildren[i].entityType === SceneConstants.EntityType.GeometryGroup) {
                        groupCount++;
                        binded_object = {
                            entity: this.entityChildren[i],
                            name: 'Groupe Géometrique ' + groupCount,
                            preview: null
                        };
                    
                    } else if (this.entityChildren[i].entityType === SceneConstants.EntityType.GeometryPrimitive) {
                        binded_object = {
                            entity: this.entityChildren[i],
                            preview: null,
                            boolean: true
                        }
                        switch (this.entityChildren[i].primitiveType) {
                            case SceneConstants.GeometryPrimitiveType.box:
                                binded_object.name = 'Boite';
                                break;
                            case SceneConstants.GeometryPrimitiveType.cylinder:
                                binded_object.name = 'Cylindre';
                                break;
                            case SceneConstants.GeometryPrimitiveType.triangle:
                                binded_object.name = 'Triangle';
                                break;
                            case SceneConstants.GeometryPrimitiveType.oval:
                                binded_object.name = 'Oval';
                                break;
                            case SceneConstants.GeometryPrimitiveType.sphere:
                                binded_object.name = 'Sphere';
                                break;
                            case SceneConstants.GeometryPrimitiveType.hood:
                                binded_object.name = 'Hôte';
                                break;
                            case SceneConstants.GeometryPrimitiveType.halfarc:
                                binded_object.name = 'Demi-arche';
                                break;
                            default:
                                binded_object.name = "Undefined";
                                break;
                        }
                    }
                    if (binded_object === null) {
                        //Object not found
                        binded_object = {
                            name: 'UNDEFINED'
                        };
                    }
                    this.entityChildrenBis.push(binded_object);
                }
                if (typeof updatecallback === 'function') {
                    updatecallback();
                }
            };
        if (listId.length > 0) {
            getAssets(_ASSET_TYPE.ARRANGEMENTS, '&q._id.in=' + listId, (res: any) => {

                var resources = res.data.resources;
                if (resources !== undefined && resources !== null && resources.length > 0) {
                    callback(resources);
                } else {
                    callback([]);
                }
            });
        } else {
            callback([]);
        }

    }
}